import { PlayerProfileResponse } from 'protos'
import { playerProfilePalette } from 'lib'

const isPlayerPerformance = (event: PlayerProfileResponse.TimelineEvent) => !event.bonus && event.value > 0
const isTeamBonus = (event: PlayerProfileResponse.TimelineEvent) => !!event.bonus && event.value > 0
const isPenalty = (event: PlayerProfileResponse.TimelineEvent) => event.value < 0

const getTimelineEventColor = (event: PlayerProfileResponse.TimelineEvent) => {
  let color = '#FFFFFF'

  if (isPlayerPerformance(event)) {
    color = playerProfilePalette.playerPerformance[0]
  } else if (isTeamBonus(event)) {
    color = playerProfilePalette.teamBonus[0]
  } else if (isPenalty(event)) {
    color = playerProfilePalette.penalties[0]
  }

  return color
}

export default getTimelineEventColor
try {
    // @ts-ignore
    getTimelineEventColor.displayName = "getTimelineEventColor";
    // @ts-ignore
    getTimelineEventColor.__docgenInfo = { "description": "", "displayName": "getTimelineEventColor", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/lib/getTimelineEventColor.ts#getTimelineEventColor"] = { docgenInfo: getTimelineEventColor.__docgenInfo, name: "getTimelineEventColor", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/lib/getTimelineEventColor.ts#getTimelineEventColor" };
}
catch (__react_docgen_typescript_loader_error) { }